/**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2018 Photon Storm Ltd.
 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
 */

/**
 * @namespace Phaser.Cameras.Sprite3D
 */

module.exports = {

    Camera: require('./Camera'),
    CameraManager: require('./CameraManager'),
    OrthographicCamera: require('./OrthographicCamera'),
    PerspectiveCamera: require('./PerspectiveCamera')

};



//////////////////
// WEBPACK FOOTER
// ./cameras/sprite3d/index.js
// module id = 472
// module chunks = 0